export const getCollateralEmptyBoxText = (tag: string, symbol: string) => {
  switch (tag) {
    case 'collateral_disabled':
      return `${symbol} can't be used as collateral`;
    case 'collateral_enabled':
      return 'No collateral at risk';
    case 'collateral_isolation':
      return `${symbol} is in isolation mode`;
    default:
      return 'No collateral at risk';
  }
};

export const getBorrowersEmptyBoxText = (tag: string, symbol: string) => {
  switch (tag) {
    case 'borrow_disabled':
      return `${symbol} can't be borrowed`;
    case 'borrow_enabled':
      return 'No borrowers';
    case 'borrow_siloed':
      return `${symbol} is siloed`;
    default:
      return 'No borrowers';
  }
};
